
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Chip } from "primereact/chip";
import Highcharts from 'highcharts';
import bullet from "highcharts/modules/bullet.js";
import HighchartsReact from 'highcharts-react-official';
import Divider from "../../../components/menu/Divider";

bullet(Highcharts);

export default function ScoreGrauAtvidadePJ({
  scoreGrauAtividadePJ
}: {
  scoreGrauAtividadePJ: any
}) {
  const { t } = useTranslation();
 
 
  return (
    <Panel header={t('grauAtividadePJ')}>
       
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <b>Score Atividade</b>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <b>Índice de confiança</b>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <b>Descrição</b>
        </div>
      </div>
      <div className="grid">
        <div style={{padding: '0'}} className="col p-fluid flex flex-wrap">
          <Divider></Divider>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          {scoreGrauAtividadePJ.score}
        </div>
        <div className="col p-fluid flex flex-wrap">
          {scoreGrauAtividadePJ.rating}
        </div>
        <div className="col p-fluid flex flex-wrap">
          {scoreGrauAtividadePJ.description}
        </div>
      </div>
    </Panel>
  )
}
